import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'Something went wrong...',
  subheader: `We're sorry, something went terribly wrong. Please try again in a little while.`,
  buttonText: 'Return to homepage',
}
